/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { ReactComponent as Down } from 'style/imgs/icons/down.svg';
import _ from 'lodash';
import styles from './formStyles.module.scss';

interface Props {
  options: string[] | { name: string; value: string[] }[];
  selectedValues?: any[];
  isObject: boolean;
  onSelect: (chip: string) => void;
  onRemove: (chip: string) => void;
  placeholder?: string;
  title: string;
  selectionLimit?: number;
  selected: string[];
  error: boolean;
  style?: string;
}

const ChipMultiSelect: React.FC<Props> = ({
  options,
  onSelect,
  onRemove,
  placeholder,
  isObject,
  selectionLimit,
  selectedValues,
  title,
  selected,
  error,
  style,
}) => {
  const [isTitleActive, setTitleActive] = useState(false);
  const [titleColor, setTitleColor] = useState('#BBB6C5');

  useEffect(() => {
    if (!_.isEmpty(selected)) {
      setTitleActive(true);
    }
  }, [selected]);

  useEffect(() => {
    let color = '';
    if (!isTitleActive) {
      color = '#BBB6C5';
    }
    if (isTitleActive) {
      color = '#10C9BE';
    }
    if (error) {
      color = '#f44336';
    }
    setTitleColor(color);
  }, [error, isTitleActive, selected]);

  return (
    <div
      role="button"
      onKeyDown={() => null}
      onClick={() => {
        setTitleActive(true);
      }}
      onBlur={() => {
        if (_.isEmpty(selected)) {
          setTitleActive(false);
        }
      }}
      tabIndex={0}
      className={`${styles.multiSelect} ${style || ''}`}
    >
      <span
        style={
          !isTitleActive
            ? {
                top: '18px',
                fontSize: '17px',
                width: 'auto',
                color: titleColor,
              }
            : { top: '-12px', color: titleColor }
        }
      >
        {title}
      </span>
      <Multiselect
        options={options}
        onSelect={onSelect}
        onRemove={onRemove}
        displayValue="name"
        placeholder={placeholder || ''}
        isObject={isObject}
        selectionLimit={selectionLimit || 3}
        closeOnSelect={false}
        selectedValues={selectedValues}
        // https://multiselect-react-dropdown.vercel.app/?path=/docs/multiselect-dropdown--flat-array props
      />
      <Down
        style={isTitleActive ? { transform: 'rotate(180deg)' } : undefined}
      />
    </div>
  );
};

export default ChipMultiSelect;
